import keyMirror from 'react-utils/keyMirror';
export const DateFormats = {
  LONG_MONTH_DAY_AND_YEAR: 'MMMM D, YYYY',
  YEAR_AND_NUMERIC_MONTH: 'YYYYMM',
  LONG_DATE_AND_TIME: 'MMMM D, YYYY, HH:mm'
};
export const CourseCategories = keyMirror({
  NOT_TRANSLATED: null,
  MARKETING: null,
  SALES: null,
  DESIGN: null,
  PARTNER: null,
  DELIVERY: null,
  GROWTH: null,
  SERVICE: null,
  OTHER: null,
  WEB_DESIGN: null
});
export const AwardTypes = keyMirror({
  BADGE_AND_CERTIFICATE: null,
  CERTIFICATE_OF_COMPLETION: null
});
export const RequiredProductNames = keyMirror({
  crm: null,
  sales: null,
  marketing: null,
  paidMarketing: null
});
export const UPWORK_LOCAL_STORAGE_KEY = 'academy:dashboard:upwork';
export const ACADEMY_TRACKS_REDUCER_KEY = 'ACADEMY_TRACKS_REDUCER';
export const ACADEMY_DEFAULT_URL = 'https://academy.hubspot.com/certification-overview';
export const SOCIAL_LINKS = {
  facebook_share: 'https://www.facebook.com/sharer/sharer.php',
  google_share: 'https://plus.google.com/share?url=http%253A//academy.hubspot.com/certification',
  linkedin_add_to_profile: 'https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME',
  twitter_share: 'https://twitter.com/intent/tweet',
  linkedin_share: 'https://www.linkedin.com/sharing/share-offsite/'
}; // HubSpot itself is '68529' but Academy has a separate presence on LinkedIn

export const ACADEMY_LINKEDIN_ORG_ID = '16197478';
export const GENERIC_CERT_DIMENSIONS = {
  WIDTH: 1584,
  HEIGHT: 1224
};